import { render } from "./vWallet.vue?vue&type=template&id=c36371e2&scoped=true"
import script from "./vWallet.vue?vue&type=script&lang=js"
export * from "./vWallet.vue?vue&type=script&lang=js"

import "./vWallet.vue?vue&type=style&index=0&id=c36371e2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\danil\\PersonalData\\WebsiteDevelopment\\GitHub\\biorobot-factory\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c36371e2"]])

export default __exports__